/**
 * Local aonde são armazenadas todas as constantes com os nomes das mutations.
 */
export const SET_PAGE = "HOME/SET_PAGE";
export const SET_ASSETS = "HOME/SET_ASSETS";
export const SET_FILTERS = "HOME/SET_FILTERS";